import React from "react";
import { PublicPage, LegalSection } from "../components/PublicPage";

export default function Terms() {
  return (
    <PublicPage title="Terms of Service" testid="terms-page">
      <p className="text-sm text-spotter-maroon/70">Last updated: June 2026. These terms are a plain-language starting point and are not legal advice — please have them reviewed by a qualified attorney before relying on them.</p>

      <LegalSection heading="1. Who can use Spotter">
        <p>You must be at least <b>16 years old</b> to create an account. Members aged 16–17 must have a parent or guardian approve their account and oversee their activity. By using Spotter you confirm you meet these requirements.</p>
      </LegalSection>

      <LegalSection heading="2. Your content and license">
        <p>You keep <b>ownership</b> of everything you post — your photos, music, writing, and profile customizations. By posting it, you grant Spotter a non-exclusive, worldwide, royalty-free license to <b>host, display, and distribute</b> that content solely to operate and promote the service. This license ends when you delete the content or your account, except for copies already shared with others or retained for legal reasons.</p>
      </LegalSection>

      <LegalSection heading="3. Community rules">
        <p>You agree not to post content that is unlawful, harassing, hateful, infringing, sexually exploitative, or that impersonates another person. You are responsible for the music, images, and links you add to your profile.</p>
      </LegalSection>

      <LegalSection heading="4. Termination">
        <p>Spotter reserves the right to suspend or <b>terminate accounts</b> that violate these terms or our community rules, or that create legal risk for the platform or its members, at our discretion.</p>
      </LegalSection>

      <LegalSection heading="5. Copyright & DMCA">
        <p>We respect intellectual property rights. If you believe content on Spotter infringes your copyright, submit a takedown request on our <a href="/report" className="underline font-semibold">Report / DMCA page</a>. Repeat infringers will have their accounts terminated.</p>
      </LegalSection>

      <LegalSection heading="6. Disclaimer">
        <p>Spotter is provided “as is.” We do our best to keep the community safe but are not liable for user-generated content. Your use of the service is at your own risk.</p>
      </LegalSection>
    </PublicPage>
  );
}
